import * as e from 'react';
import { forwardRef, memo } from 'react';

var f=({title:r,titleId:t,...o},l)=>e.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fill:"currentColor",ref:l,"aria-labelledby":t,...o},r?e.createElement("title",{id:t},r):null,e.createElement("path",{d:"M14.3 5a6 6 0 0 0-.71-1.16A7 7 0 1 0 8 15a7 7 0 0 0 5-2l-.71-.71A5.94 5.94 0 0 1 8 14a6 6 0 1 1 4.79-9.6 4 4 0 0 1 .38.56c.11.18-.26-.16-.17 0h1.27l.1.1Z"}),e.createElement("path",{d:"M14.5 1.5h-1v3h-3v1h4v-4"})),i=forwardRef(f),n=memo(i),h=n;

export { h as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-LTS7SRC2.mjs.map